var PasswordProtect = {
  term_id: "",

  showPasswordModal: function() {
    console.log("showPasswordModal");
    jQuery(".small.ui.modal").modal("show");

    /*
     * Fix for Avada Theme:
     * where modal does not show when you open it for the second time after closing
     */
    if (jQuery(".small.ui.modal").is(":visible")) {
    } else {
      jQuery(".small.ui.modal").show();
    }
  },

  correctPassword: function(ajaxResponse) {
    var input_selector = ".pauple_helpie.ui.modal input[type=password]";
    jQuery(input_selector).css("border-color", "#75d69c");
    if (jQuery(".pauple_helpie.ui.modal .password-status")) {
      jQuery(".pauple_helpie.ui.modal .password-status").remove();
    }

    jQuery(input_selector).after(
      "<span class='password-status correct'>Verified. Redirecting you now <img class='redirect-gif' src='" +
        helpieGlobal.plugin_url +
        "public/images/redirecting.gif' /></span>"
    );
    window.location.assign(ajaxResponse);
  },

  wrongPassword: function() {
    var input_selector = ".pauple_helpie.ui.modal input[type=password]";
    jQuery(input_selector).css("border-color", "#fe6c61");
    if (jQuery(".pauple_helpie.ui.modal .password-status")) {
      jQuery(".pauple_helpie.ui.modal .password-status").remove();
    }

    jQuery(input_selector).after(
      "<span class='password-status wrong'>Wrong Password</span>"
    );
  },

  passwordSubmit: function() {
    // console.log('passwordSubmit: ' + jQuery('.pauple_helpie.ui.modal input[type=password]').length);
    var that = this;
    var input = jQuery(".pauple_helpie.ui.modal input[type=password]").val();
    var nonce = helpieKBFrontEndNonce;

    if (that.origin_location) {
      var origin_location = that.origin_location;
    } else {
      var origin_location = "term_page";
    }

    var post_id = "";
    if (that.post_id) {
      var post_id = that.post_id;
    }

    console.log("term_id: " + this.term_id);
    var data = {
      action: "helpie_validate_password_input",
      nonce: nonce,
      term_id: this.term_id,
      password_input: input,
      origin_location: origin_location,
      post_id: post_id,
      destination: that.destination
    };

    // console.log("input: " + input);
    // console.log("term_id: " + this.term_id);

    jQuery.post(my_ajax_object.ajax_url, data, function(response) {
      var ajaxResponse = JSON.parse(response);
      console.log("ajaxResponse: " + ajaxResponse);
      if (ajaxResponse == 0) {
        that.wrongPassword();
      } else {
        if (ajaxResponse.match("http")) {
          that.correctPassword(ajaxResponse);
        } else {
          that.wrongPassword();
        }
      }
    });
  },

  onProtectedClick: function(element) {
    console.log("onProtectedClick");
    var thisView = this;
    var classes = jQuery(element)
      .attr("class")
      .split(" ");

    if (jQuery(element).data("origin")) {
      thisView.origin_location = jQuery(element).data("origin");
    }

    for (var ii = 0; ii < classes.length; ii++) {
      var className = classes[ii];
      console.log("className: " + className);
      if (className.match("term-id")) {
        thisView.term_id = className.replace("term-id-", "");
      }
    }

    console.log("termID: " + thisView.term_id);
    console.log("my_ajax_object.ajax_url: " + my_ajax_object.ajax_url);
    var nonce = helpieKBFrontEndNonce;
    var data = {
      action: "helpie_check_transient_password_action",
      nonce: nonce,
      term_id: thisView.term_id
    };

    jQuery.post(my_ajax_object.ajax_url, data, function(response) {
      var ajaxResponse = JSON.parse(response);
      console.log(
        "helpie_check_transient_password ajaxResponse: " + ajaxResponse
      );
      if (ajaxResponse && ajaxResponse != 0 && ajaxResponse.match("http")) {
        window.location.assign(ajaxResponse);
      } else {
        thisView.showPasswordModal();
      }
    });
  },

  eventhandlers: function() {
    var that = this;

    jQuery("#helpie-password-modal.small.ui.modal").modal({
      // blurring: true,
      transition: "fade up",
      observeChanges: true,
      onApprove: function(event) {
        console.log("password-modal onApprove");
        that.passwordSubmit();
        return false;
      }
    });
    jQuery(".pauple_helpie.ui.modal").modal("hide");

    /* When  jQuery('.small.ui.modal').modal({ }); is not working .
        Note: Click events are not triggering in Avada Theme
      */

    jQuery("#helpie-password-modal .actions .positive").click(function() {
      that.passwordSubmit();
    });

    jQuery("#helpie-password-modal.modal .actions .deny").click(function() {
      console.log("deny");
      jQuery(".modal-backdrop.in").hide();
      jQuery(".pauple_helpie.ui.modal").hide();
    });

    /* Protected clicks */

    jQuery(".pauple-helpie-single-sidebar .page-scroll-nav li.protected").click(
      function() {
        that.onProtectedClick(this);
      }
    );

    jQuery(".pauple-helpie-single-sidebar div.protected").click(function() {
      that.onProtectedClick(this);
    });

    // Search Results

    jQuery(".helpie-search-listing .helpie-element.protected").click(
      function() {
        that.post_id = jQuery(this).data("post-id");
        that.term_id = jQuery(this).data("term-id");

        console.log("term-id: " + that.term_id);
        that.destination = "single-page";

        that.origin_location = "search-page";
        that.onProtectedClick(this);
      }
    );

    jQuery(".helpie-articles-listing .helpie-element.protected").click(
      function() {
        that.post_id = jQuery(this).data("post-id");
        that.term_id = jQuery(this).data("term-id");
        that.destination = "single-page";
        that.onProtectedClick(this);
      }
    );
    // Category Listing elements with term-id-x should be clicked

    jQuery(
      "#helpie-categories-section-boxed .helpie-category-listing .helpie-element.protected"
    ).click(function() {
      that.onProtectedClick(this);
    });

    jQuery(
      "#helpie-categories-section-boxed1 .helpie-category-listing .helpie-element.protected li"
    ).click(function() {
      that.onProtectedClick(this);
    });

    jQuery(
      "#helpie-categories-section-modern .helpie-category-listing .helpie-element.protected"
    ).click(function() {
      that.onProtectedClick(this);
    });

    jQuery(".helpie-enter-password").click(function() {
      that.term_id = jQuery(this).attr("data-term-id");

      if (jQuery(this).data("origin")) {
        that.origin_location = jQuery(this).data("origin");
      }

      if (jQuery(this).data("post-id")) {
        that.post_id = jQuery(this).data("post-id");
      }

      that.showPasswordModal();
    });
  },

  load: function() {
    console.log("PasswordProtect load() ");
    var that = this;
    that.destination = "category-page";
    // console.log("modal there: " + jQuery('.small.ui.modal').length);
    // jQuery('.small.ui.modal').modal('hide');
    setTimeout(function() {
      that.eventhandlers();
    }, 300);
  }
};
module.exports = PasswordProtect;
